import { put } from 'utils';

export default function approveQualification(
  payload = {},
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  put({ apiKey: 'overview.orders.updateStatus.qualification' }, payload)
    .then(({ statusCode, data }) => {
      if (statusCode === 208) {
        const err = new Error('Already Done');
        err.displayMessage = 'Request was already processed.';
        err.statusCode = 208;
        throw err;
      }
      onSuccess(data);
    })
    .catch(onError)
    .finally(onFinally);
}
